import { render, staticRenderFns } from "./client.layout.vue?vue&type=template&id=b21e1b32&scoped=true&lang=pug"
import script from "./client.layout.vue?vue&type=script&lang=ts"
export * from "./client.layout.vue?vue&type=script&lang=ts"
import style0 from "./client.layout.vue?vue&type=style&index=0&id=b21e1b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e1b32",
  null
  
)

export default component.exports